import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class SearchTableAnalyticsService {
  constructor(private readonly http: HttpClient) {
  }

  log(filters: any[]) {
    let filtersPayload = convertToKeyValuePairs(filters);
    filtersPayload = sortAlphabeticallyByKey(filtersPayload);

    this.http.post('service/api/v1/analytics/usage/search', filtersPayload)
      .subscribe({
        error: error => console.error('could not send usage statistics', error)
      });
  }
}

const convertToKeyValuePairs = (filters: any[]) => {
  const parameters = {};

  filters.filter(filter => filter?.value?.toString()?.length > 0)
    .forEach((filter) => {
      let value = filter.value;

      if (filter.disabled) {
        value += '_disabled';
      }

      parameters[filter.id] = value;
    });

  return parameters;
}

const sortAlphabeticallyByKey = (filters: any) => {
  return Object.keys(filters).sort().reduce((r, k) => {
    r[k] = filters[k];
    return r;
  }, {})
}
